module.exports = __webpack_public_path__ + "static/media/shape2_6.2a6ca92f.obj";